import {isSignedIn} from './selectors'
import {redirectToSignIn} from '../navigation/redirects'

export function redirectIfNotSignedIn(state) {
  if(! isSignedIn(state))
    redirectToSignIn()
}

